module.exports = __webpack_public_path__ + "media/images/icons/country_flags/co-2035da4efa474be5bb4bf93fb3d73174.svg";